export type Role = 'DEVELOPER' | 'ADMIN' | 'USER'

export type Action =
	// Page access
	| 'settings:manage'
	| 'users:manage'
	| 'review:view'
	| 'dashboard:view'
	| 'monitoring:view'
	| 'orgs:manage'
	// Feature permissions
	| 'permits:assign'
	| 'permits:manage'
	| 'cycles:manage'
	| 'debug:view-source'

export const Actions = {
	SETTINGS_MANAGE: 'settings:manage',
	USERS_MANAGE: 'users:manage',
	REVIEW_VIEW: 'review:view',
	DASHBOARD_VIEW: 'dashboard:view',
	MONITORING_VIEW: 'monitoring:view',
	ORGS_MANAGE: 'orgs:manage',
	PERMITS_ASSIGN: 'permits:assign',
	PERMITS_MANAGE: 'permits:manage',
	CYCLES_MANAGE: 'cycles:manage',
	DEBUG_VIEW_SOURCE: 'debug:view-source',
} as const satisfies Record<string, Action>

const PERMISSIONS: Record<Role, readonly Action[]> = {
	DEVELOPER: [
		Actions.SETTINGS_MANAGE,
		Actions.USERS_MANAGE,
		Actions.REVIEW_VIEW,
		Actions.DASHBOARD_VIEW,
		Actions.MONITORING_VIEW,
		Actions.ORGS_MANAGE,
		Actions.PERMITS_ASSIGN,
		Actions.PERMITS_MANAGE,
		Actions.CYCLES_MANAGE,
		Actions.DEBUG_VIEW_SOURCE,
	],
	ADMIN: [
		Actions.SETTINGS_MANAGE,
		Actions.USERS_MANAGE,
		Actions.REVIEW_VIEW,
		Actions.DASHBOARD_VIEW,
		Actions.PERMITS_ASSIGN,
		Actions.PERMITS_MANAGE,
		Actions.CYCLES_MANAGE,
	],
	USER: [Actions.PERMITS_MANAGE],
}

export function can(role: Role | undefined, action: Action): boolean {
	if (!role) return false
	return PERMISSIONS[role].includes(action)
}
